import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class MunicipalityAdd extends Component{
	render(){
		const {municipalities} =this.props;
		let mc = _.find(municipalities.permissions, (o) => {return o==='Create'});
		return (
			mc ?
				<p>
					<NavLink to={`/municipios/crear`} className="button is-small is-inm-purple">{'Agregar Municipio'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(MunicipalityAdd);


// WEBPACK FOOTER //
// ./src/elements/municipalities/widget/municipality_add.jsx